import type TranscriptWord from './transcriptWord';
import SubtitleCue from './subtitleCue';
import { safeArrayAccess } from '../util/safeArrayAccess';

export default class Subtitle {
  cues: SubtitleCue[] = [];
  get currentCue() {
    return safeArrayAccess(this.cues, this.cues.length - 1);
  }
  constructor() {
    const cue = new SubtitleCue();
    this.cues.push(cue);
  }
  public addNewCue() {
    const cue = new SubtitleCue();
    this.cues.push(cue);
  }
  public addWordToCurrentCue(word: TranscriptWord) {
    this.currentCue.addWord(word);
  }
}

/**
 * Converts Web VTT subtitles to SRT subtitles
 * Based on https://github.com/jansenicus/vtt-to-srt.py/blob/master/vtt_to_srt.py
 * @param {String} vttString Containing full VTT file content
 */
export const convertVttToSrt = (vttString: string) => {
  let result = vttString.replace(/(\d\d:\d\d:\d\d).(\d\d\d) --> (\d\d:\d\d:\d\d).(\d\d\d)(?:[ \-\w]+:[\w%\d:]+)*\n/g, '$1,$2 --> $3,$4\n');
  result = result.replace(/(\d\d:\d\d).(\d\d\d) --> (\d\d:\d\d).(\d\d\d)(?:[ \-\w]+:[\w%\d:]+)*\n/g, '$1,$2 --> $3,$4\n');
  result = result.replace(/(\d\d).(\d\d\d) --> (\d\d).(\d\d\d)(?:[ \-\w]+:[\w%\d:]+)*\n/g, '$1,$2 --> $3,$4\n');
  result = /WEBVTT\n\n/.exec(result) ? result.replace(/WEBVTT\n\n/g, '') : result.replace(/WEBVTT\n/g, '');
  result = result.replace(/Kind:[ \-\w]+\n/g, '');
  result = result.replace(/Language:[ \-\w]+\n/g, '');
  result = result.replace(/<c[.\w\d]*>/g, '');
  result = result.replace(/<\/c>/g, '');
  result = result.replace(/<\d\d:\d\d:\d\d.\d\d\d>/g, '');
  result = result.replace(/::[-\w]+\([-.\w\d]+\)[ ]*{[.,:;() \-\w\d]+\n }\n/g, '');
  result = result.replace(/Style:\n##\n/g, '');
  return result;
};
